const l = {
  name: "PaperPlane",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,0L29.1,40l-7.9-21.2L0,10.9L40,0z M6.5,11.2l15.2,5.7L35.2,3.4L6.5,11.2z M28.8,33.5l7.8-28.7L23.2,18.3
			L28.8,33.5z"/>
		<path class="st0" d="M0.3,38.3l1.4,1.4l14-14l-1.4-1.4L0.3,38.3z"/>
		<path class="st0" d="M0.3,26.3l7-7l1.4,1.4l-7,7L0.3,26.3z"/>
		<path class="st0" d="M19.3,31.3l-7,7l1.4,1.4l7-7L19.3,31.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as PaperPlane
};
